import { Component, Inject, inject, OnInit } from '@angular/core';
import { AmplifyUser } from '@aws-amplify/ui';
import { ConfigService } from '../../../config.service';
import { MatDialog } from '@angular/material/dialog';
import { MatSnackBar } from '@angular/material/snack-bar';
import { AWSLambda } from 'src/app/AWSLambda.service';
import { Router,ActivatedRoute} from '@angular/router';
import { Auth } from 'aws-amplify';
import { GlobalDataService } from '../../../services/global-data.service';
import { detectEnv } from 'src/app/services/Enviroment';
import { TranslateService } from '@ngx-translate/core';
import { AuthService } from "../../../services/auth.service";
import { BoRolesCheckService } from 'src/app/components/rolesCheck/bo-roles-check.service';

@Component({
  selector: 'app-backoffice-transactions',
  templateUrl: './TxUsuarios.component.html',
  styles: [
    `
      .loading-mask {
        position: fixed;
        top: 0;
        left: 0;
        width: 100%;
        height: 100%;
        background-color: rgba(0, 0, 0, 0.5);
        display: flex;
        justify-content: center;
        align-items: center;
        z-index: 9999;
      }
    `,
  ],
})
export class TxUsuariosComponent implements OnInit {
  _snackBar = inject(MatSnackBar);
  showSpinner = false;
  window = window;
  dialog = inject(MatDialog);
  lambda = inject(AWSLambda);
  rolesCheck = inject(BoRolesCheckService);
  protected currentEnv = detectEnv();
  user!: AmplifyUser;
  canAccess = false;
  balanceAmount: number | null = null;
  owner: string | null = null; 
  fechaInicio: string = '';
  fechaFin: string = '';

  // Propiedades para manejar transacciones
  transactionList: any[] = [];
  paginationToken: string | null = null;
  hasMoreTransactions: boolean = true;
  loadingTransactions: boolean = false;
  filteredCounts: { transactionList: number } = { transactionList: 0 };
  filterTransactions: any[] = [];

  constructor(
    private router: Router,
    private route: ActivatedRoute,
    private translate: TranslateService,
    private auth: AuthService,
  ) {}

  async ngOnInit() {
    this.canAccess = await this.rolesCheck.checkAccess();
    if (!this.canAccess) {
      return;
    }

    const today = new Date();
    const yyyy = today.getFullYear();
    const mm = String(today.getMonth() + 1).padStart(2, '0');
    const dd = String(today.getDate()).padStart(2, '0');
    this.fechaInicio = `${yyyy}-${mm}-${dd}`;
    this.fechaFin = this.fechaInicio;

    await this.auth.refresh()
    this.user = await Auth.currentAuthenticatedUser();
    this.owner = this.route.snapshot.queryParamMap.get('owner');
    this.transactionList = [];
    if (this.owner) {
     console.log('opcion owner:');
      await this.getTransactionList(this.owner,this.fechaInicio,this.fechaFin);
      await this.getbalance(this.owner);
    } else {
      console.log('opcion solo fechasa:');
      await this.getTransactionList(undefined, this.fechaInicio, this.fechaFin);
    }

  }

  async getbalance(owner: string) {
  try {
    const response = await this.lambda.getLambdaFunction('lambda', '/transactions/balance', {
      queryStringParameters: { owner }
    });
    this.balanceAmount = response.amount;
  } catch (err) {
    console.error("Error al obtener el balance:", err);
    this.balanceAmount = null;
  }
}


  async getTransactionList(owner?: string,fechaInicio?: string, fechaFin?: string): Promise<void> {
    if (this.loadingTransactions || !this.hasMoreTransactions) return;
    this.loadingTransactions = true;
    const queryParams: any = {};
    if (owner) queryParams.owner = owner;
    if (fechaInicio) queryParams["fechaInicio"] = fechaInicio;
    if (fechaFin) queryParams["fechaFin"] = fechaFin;

     console.log("fini:",fechaInicio,"-ffin: ",fechaFin)
    try {
      let response;
      queryParams["resumen"] = "true"
      response = await this.lambda.getLambdaFunction('lambda', '/get/TxUsers', {
          queryStringParameters: queryParams,
      });

      if (response && response.data && Array.isArray(response.data)) {
        this.transactionList = [...this.transactionList, ...response.data];

        console.log('Transacciones obtenidas:',this.transactionList);
        const uniqueactivo = Array.from(
          new Set(response.data.map((transaction: { Activo: any }) => transaction.Activo))
        ).map(type => ({
          key: type,
          value: type
        }));



        this.filterTransactions = [
          { key: 'full_name', type: 'text', label: "Nombre" },
          { key: 'phonenumber', type: 'Text', label:"Telefono"  },
          { key: 'email', type: 'Text', label: "Email"  },
          { key: 'phonenumber', type: 'text', label: "phonenumber" },
          { key: 'Activo', type: 'select', label: "status",options: uniqueactivo  },
          // { key: 'amount', type: 'text', label: this.translate.instant('COMPONENTS.TRANSACTION.AMOUNT') },
          // { key: 'source', type: 'text', label: this.translate.instant('COMPONENTS.TRANSACTION.SOURCE') },
          // { key: 'destination', type: 'text', label: this.translate.instant('COMPONENTS.TRANSACTION.DESTINATION') },
          // { key: 'owner', type: 'text', label: this.translate.instant('COMPONENTS.TRANSACTION.OWNER') },
          // { key: 'status', type: 'select', label: this.translate.instant('COMPONENTS.TRANSACTION.STATUS'), options: uniqueStatuses },
        ];
      } else {
        this.hasMoreTransactions = false;
      }
    } catch (error) {
      console.error('Error al obtener transacciones:', error);
    } finally {
      this.loadingTransactions = false;
    }
  }

  async loadMoreTransactions(): Promise<void> {
    // if (this.hasMoreTransactions) {
    //   await this.getTransactionList();
    // }
  }

  async buscarPorFechas(): Promise<void> {
    if (!this.fechaInicio || !this.fechaFin) {
      console.warn('Debe especificar ambas fechas');
      this._snackBar.open('Debe especificar ambas fechas', 'Close', { duration: 5000 });
      return;
    }

    if (new Date(this.fechaInicio) > new Date(this.fechaFin)) {
      console.warn('La fecha de inicio no puede ser mayor que la fecha de fin');
      this._snackBar.open('La fecha de inicio no puede ser mayor que la fecha de fin', 'Close', { duration: 5000 });
      return;
    }

    // Formatea las fechas si vienen como objetos Date
    const formatDate = (fecha: string | Date) => {
      const d = new Date(fecha);
      return d.toISOString().split('T')[0]; // yyyy-MM-dd
    };

    const fechaInicioFormatted = formatDate(this.fechaInicio);
    const fechaFinFormatted = formatDate(this.fechaFin);
    this.transactionList = [];
   
    await this.getTransactionList(this.owner || undefined, fechaInicioFormatted, fechaFinFormatted);
  }

  onFiltersChanged(filters: any) {
    console.log('Filters updated:', filters);
  }

  onTransactionClick(transaction: any): void {
    this.router.navigate(['/backoffice/users', transaction.owner]);
  }

  delay(ms: number) {
    return new Promise(resolve => setTimeout(resolve, ms));
  }
}